module.exports = __webpack_public_path__ + "img/resource01.0574c1e6.png";